<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  reportName="HrmPersonnel"
  pathPreFix="HRM"
  (valueChangeByApiName)="onChanged($event)"
  (cancelChange)="cancel()"
  [columns]="columns"
  (submitChange)="save()">
  <ng-container class="content">
    <ssg-tabset class="tabcontainer tabcontentbox">
      <ssg-tab tabTitle="عکس و امضاء">
        <div *ngIf="formGroupPhoto && PersonnelPhotocolumns && PersonnelPhotocolumns.length > 0">
          <form-control-model>
            [defaultHeight]="25" [_columns]="PersonnelPhotocolumns" [group]="formGroupPhoto" [model]="model.PersonnelPhoto"
          </form-control-model>
        </div>

        <!-- PersonnelPhoto -->
      </ssg-tab>
      <ssg-tab tabTitle="سایر اطلاعات">
        <editable-grid [columns]="PersonnelOtherInfos" [(dataList)]="model.PersonnelOtherInfos" [DefaultValues]="DefaultValues"> </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="نظام وظیفه">
        <editable-grid [columns]="PersonnelServiceds" [(dataList)]="model.PersonnelServiceds" [DefaultValues]="DefaultValues"> </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="رزمندگی">
        <div *ngIf="formGroupPersonnelFighter && PersonnelFightercolumns && PersonnelFightercolumns.length > 0">
          <form-control-model>
            [defaultHeight]="25" [columns]="PersonnelFightercolumns" [group]="formGroupPersonnelFighter" [model]="model.PersonnelFighter"
          </form-control-model>
        </div>

        <!--PersonnelFighter  -->
      </ssg-tab>
      <ssg-tab tabTitle="سوابق کاری">
        <editable-grid [columns]="PersonnelWorkRecordss" [(dataList)]="model.PersonnelWorkRecordss" [DefaultValues]="DefaultValues"> </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="سوابق آموزش">
        <editable-grid [columns]="PersonnelStudyRecords" [(dataList)]="model.PersonnelStudyRecords" [DefaultValues]="DefaultValues"> </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="زبان">
        <editable-grid [columns]="PersonnelLanguages" [(dataList)]="model.PersonnelLanguages" [DefaultValues]="DefaultValues"> </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="معرفها">
        <editable-grid [columns]="PersonnelRecommenders" [(dataList)]="model.PersonnelRecommenders" [DefaultValues]="DefaultValues"> </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="بستگان">
        <editable-grid [columns]="PersonnelRelativess" [(dataList)]="model.PersonnelRelativess" [DefaultValues]="DefaultValues"> </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="آدرس">
        <editable-grid [columns]="PersonnelAddresss" [(dataList)]="model.PersonnelAddresss" [DefaultValues]="DefaultValues"> </editable-grid>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
